import Item from './item';

const InputGroups = ({
  handleSelectInputGroup,
  inputGroups,
}: IInputGroupsProps) => {
  return (
    <>
      <div className="grid grid-cols-4 gap-2 text-center">
        {inputGroups.map(item => (
          <Item
            handleSelectInputGroup={handleSelectInputGroup}
            item={item}
            key={item.id}
          />
        ))}
      </div>
    </>
  );
};

export default InputGroups;
